import React from "react";
import {Box} from "@mui/system";
import {organizationSettingsService} from "_services";
import {ToggleField, useToggle} from "../MsgDataSourceTrendsToggles";

/**
 * When enabled, required custom fields that a reply was missing (found by the pre-check or in the platform's dispatch
 * error) are added to this data source's custom fields automatically.
 */
export default function AutoAddRequiredCustomFieldsToggle({msgDataSource}) {
    const toggle = useToggle({
        initial: msgDataSource?.autoAddRequiredCustomFields,
        persist: async (autoAddRequiredCustomFields) => {
            const response = await organizationSettingsService.updateMsgDataSourceCustomFieldSettings(
                msgDataSource?.id,
                {autoAddRequiredCustomFields}
            );
            return response?.data?.autoAddRequiredCustomFields;
        },
        successMessage: (enabled) => enabled
            ? 'Required custom fields will be added automatically'
            : 'Required custom fields will no longer be added automatically',
        fallbackMessage: 'Failed to update custom field settings',
    });

    return (
        <Box sx={style.container}>
            <ToggleField label="Automatically add required custom fields" toggle={toggle}/>
            <Box sx={style.helperText}>
                Adds fields required by the platform when a reply fails because they were missing
            </Box>
        </Box>
    );
}

const style = {
    container: {
        mb: '10px',
    },
    helperText: {
        color: '#6b6b6b',
        fontSize: '13px',
    },
};
